// extracted by mini-css-extract-plugin
export default {"sideBar":"sideBar_sideBar__MJdQz","hide":"sideBar_hide__o09RU","hidden":"sideBar_hidden__Fe7fZ","title":"sideBar_title__1amLj"};